import _post from "./NoBodyPost"
import constantURI from "../URI"
import { ASAPDB } from "../ConstantURI"

const ASAPAuthenticate = async () => {
    var result = false;
    const client = JSON.parse(localStorage.getItem("ClientIdGlobal"));
    const username = JSON.parse(localStorage.getItem("Username"));
    const token = JSON.parse(localStorage.getItem("Token"));
    const db = ASAPDB;
    var password = "";
    var url = "";
    if (client === 2002) {
        password = "admin_AsAp";
        url = constantURI() + "Authentication?token=" + token + "&user=" + username + "&username=" + username + "&password=" + "admin_AsAp" + "&db=" + db;
    }
    else {
        password = JSON.parse(localStorage.getItem("Password"));
        url = constantURI() + "Authentication?token=" + token + "&user=" + username + "&username=" + username + "&password=" + password + "&db=" + db;
    }
    if (navigator.onLine) {
        setTimeout(await _post(url).then((response) => {
            if (response) {
                return response.json().then((data) => {
                    if (data.result === undefined) {
                        result = false;
                    }
                    else if (data === { Message: "An error has occurred." }) {
                        result = "";
                    }
                    else result = true;
                })
            }
            else {
                result = false;
            }
        }), 30000);
    }
    else {
        result = false;
    }
    return result;
}
export default ASAPAuthenticate;


